<template>
  <div v-show="!autoSubmit" class="questionnaire-question-buttons">
    <div class="questionnaire-body"/>

    <Modal
        v-if="isModalVisible"
        @close="closeModal"
        @finish="finish"
    />

    <div class="questionnaire-question-question">
      Vous avez terminé le test !
    </div>

    <button class="btn btn-quaternary btn-block" @click="router.go()">
      <span>Vérifier mes réponses</span>
    </button>

    <button
        class="btn btn-primary btn-block"
        @click="showModal">
      <span>Valider mes réponses</span>
    </button>
  </div>
</template>

<script setup>
import {onBeforeMount, ref} from 'vue';
import { useRouter } from 'vue-router';
import Modal from '@/components/Modal/Questionnaire/Finish.vue';
import UserService from "@/services/user.service";

const props = defineProps({
  idUserTest: {
    type: Number,
    required: true
  },
  autoSubmit: {
    type: Boolean,
    required: true
  }
});

onBeforeMount(() => {
  if (props.autoSubmit) {
    finish()
  }
})

const router = useRouter();
const isModalVisible = ref(false);

const showModal = () => {
  isModalVisible.value = true;
};

const closeModal = () => {
  isModalVisible.value = false;
};

const finish = () => {
  UserService.saveQuestionnaireToEva().then(
      (response) => {
        UserService.terminatedTest(props.idUserTest).then(
            setTimeout(function (routerInstance) {
              routerInstance.push({name: 'mes-tests'})
            }, 1000, router)
        );
      },
      (error) => {
        alert(error.response.data.detail)
      }
  )
};
</script>
